import { IconName } from "Components/UI";
import { IBaseResponse } from '../BaseResponse';

export interface IConstructionSiteDisciplineLibraryItem {
  ConstructionSiteDisciplineLibraryItemId: number;
  Name: string;
  Acronym: string;
  Icon?: IconName;
  Order: number;
  ConstructionSiteDisciplineLibraryFk: number;
}

export interface IConstructionSiteDisciplineLibrary {
  ConstructionSiteDisciplineLibraryId: number;
  Name: string;
  Description?: string;
  IconName?: IconName;
  Type: ConstructionSiteDisciplineLibraryEnum;
  Items: IConstructionSiteDisciplineLibraryItem[];
}

export interface IConstructionSiteDisciplineLibraryResponse
  extends IBaseResponse<IConstructionSiteDisciplineLibrary[]> {}

export interface IConstructionSiteDisciplineLibraryRequest {
  constructionSiteId: number;
  constructionSiteDisciplineLibraryId: number;
  constructionSiteDisciplineLibraryItems: number[];
  type: ImportedDisciplineLibraryTypeEnum;
}

export enum ImportedDisciplineLibraryTypeEnum {
  Predefined,
  ConstructionSite,
}

export enum ConstructionSiteDisciplineLibraryEnum {
  Standard,
  MarketStandard,
  ConstructionSite,
}

export interface IDisciplineLibraryItem {
  name: string;
  acronym: string;
  icon: IconName;
}

export interface ICreateDisciplineLibraryRequest {
  name: string;
  description: string;
  type: number;
  iconName: IconName;
  items: IDisciplineLibraryItem[];
}

export interface IUpdateDisciplineLibraryRequest {
  disciplineLibraryId: number;
  disciplineLibrary: ICreateDisciplineLibraryRequest;
}
